export enum AttachmentLoaderKey {
  LIST_ATTACHMENTS = 'list-attachments',
  UPLOAD_ATTACHMENT = 'upload-attachment',
  DELETE_ATTACHMENT = 'delete-attachment',
}
